module.exports = __webpack_public_path__ + "static/media/ic_outliers.bb3f48fc.svg";